export * from './ng2-carouselamos.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/ng2-carouselamos/dist/components/ng2-carouselamos/index.js
// module id = ../../../../../src/app/ng2-carouselamos/dist/components/ng2-carouselamos/index.js
// module chunks = main